"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "chialamberto": {
    "30498d2e": [{
      "hkey": "17c221be",
      "slug": "breno-bussoni-mottera",
      "name": "Breno-Bussoni-Mottera",
      "primary": true,
      "skipSearch": false
    }],
    "6c7bb692": [{
      "hkey": "17c221be",
      "slug": "breno-bussoni-mottera",
      "name": "Breno-Bussoni-Mottera",
      "primary": false,
      "skipSearch": false
    }],
    "bfe64586": [{
      "hkey": "17c221be",
      "slug": "breno-bussoni-mottera",
      "name": "Breno-Bussoni-Mottera",
      "primary": false,
      "skipSearch": false
    }],
    "breno": [{
      "hkey": "17c221be",
      "slug": "breno-bussoni-mottera",
      "name": "Breno-Bussoni-Mottera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bussoni": [{
      "hkey": "17c221be",
      "slug": "breno-bussoni-mottera",
      "name": "Breno-Bussoni-Mottera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "chialamberto"
    }],
    "c6ef7530": [{
      "hkey": "9b645350",
      "slug": "chialamberto",
      "name": "Chialamberto",
      "primary": true,
      "skipSearch": false
    }],
    "mottera": [{
      "hkey": "17c221be",
      "slug": "breno-bussoni-mottera",
      "name": "Breno-Bussoni-Mottera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "chialamberto"
    }],
    "prati-della-via": [{
      "hkey": "9b645350",
      "slug": "chialamberto",
      "name": "Chialamberto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;